// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"265":"50816401187862a6","371":"8bae8e3526623989","619":"9d325542cb1c52f3","670":"964a36a29afea2f2","888":"16fa1a176ef9eae9"}[chunkId] + ".css";
};